import React from 'react';
import { useThemeColors } from '../../hooks/useTheme';
import './Home.scss';
import p1 from '../../assets/images/p1.jpg'
const Home: React.FC = () => {
  const colors = useThemeColors();

  return (
    <section 
      id="home" 
      className="home" 
      style={{ 
        backgroundColor: colors.background,
        color: colors.primary
      }}
    >
      <div className="home__container">
        <div 
          className="home__content"
          style={{
            backgroundColor: colors.surface,
            border: `1px solid ${colors.border}`
          }}
        >
          <h1 className="home__title">Anantha Pradeep</h1>
          <h2 className="home__subtitle">Software Engineer | Full-Stack Developer | DevOps Enthusiast</h2>
          <p className="home__description">
            Full-Stack Developer and DevOps Engineer with over 6+ years of industry experience, specializing in modern web and mobile application development. Demonstrated expertise in .NET, Angular, React Native, and SQL-based backends, alongside deep proficiency in CI/CD pipelines, containerization, and cloud infrastructure on AWS and Azure. Adept at delivering secure, scalable, and high-performance systems in Agile environments, with a strong focus on engineering best practices and cross-functional collaboration.
          </p>
        </div>
        <div 
          className="home__image-wrapper"
          style={{
            border: `1px solid ${colors.border}`
          }}
        >
          <div 
            className="home__image"
            style={{
              backgroundColor: colors.accent,
              backgroundImage: `url(${p1})` 
            }}
          ></div>
        </div>
      </div>
    </section>
  );
};

export default Home;